import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=54bfae5a&scoped=true&"
import script from "./VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VerifyEmail.vue?vue&type=style&index=1&id=54bfae5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfae5a",
  null
  
)

export default component.exports